import { ModelStrStr, SESSION } from '@app-lib/models/-index';

import { format } from 'date-fns';

export interface IFilterTableBase {
  GetSessionFilterStato(key: string): ModelStrStr[] | any[];
  SetSessionFilterStato(filter_table: ModelStrStr[], key: string): void;
  OnFilterTable(campo: string, valore: any, cname: string): ModelStrStr[];
}

export abstract class FilterTableBase implements IFilterTableBase {
  /* constructor(protected _component: string) {}

  get session_name() {
    let str: string = this._component;
    // let str: string = this.constructor.name.toLowerCase();
    str = str.replace('local', '').replace('service', '').replace('component', '');
    return SESSION.PREFIX_FILTER_TABLE + str;
  }*/

  public GetSessionFilterStato(partial_key): ModelStrStr[] | any[] {
    partial_key = SESSION.PREFIX_FILTER_TABLE + partial_key;
    const ft = sessionStorage.getItem(partial_key);
    if (ft) {
      return JSON.parse(ft) || [];
    } else {
      return [];
    }
  }

  public SetSessionFilterStato(filter_table: any[], partial_key: string) {
    partial_key = SESSION.PREFIX_FILTER_TABLE + partial_key;
    const data = JSON.stringify(filter_table);
    sessionStorage.setItem(partial_key, data);
  }
  public DellSessionFilterStato(partial_key: string) {
    partial_key = SESSION.PREFIX_FILTER_TABLE + partial_key;
    sessionStorage.removeItem(partial_key);
  }
  //
  public DateToCompare(date): string {
    return format(new Date(date).setHours(0, 0, 0, 0), 'dd/MM/yy');
  }

  // setta la filter_table (in memoria e in session ) dei filtri
  public OnFilterTable(campo: string, valore: any, cname: string): ModelStrStr[] {
    const filter_table: ModelStrStr[] = this.GetSessionFilterStato(cname);

    let ret: ModelStrStr[] = [];
    if (filter_table != null) {
      let data: any[] = [...filter_table];
      const f: ModelStrStr = data.find((f) => f.Text == campo);

      if (f == undefined) {
        // non c'era: dati passati dalla dialog aggiungo
        const cur_val = filter_table;
        const obj: ModelStrStr = { Value: valore, Text: campo };
        const up_val = [...cur_val, obj];
        ret = up_val;
      } else {
        // se c'era lo elimina non passa per la dialog
        const i: number = filter_table.indexOf(f);
        data.splice(i, 1);
        ret = data;
      }
    } else {
      // nuovo dati dala dialog
      const obj: ModelStrStr = { Value: valore, Text: campo };
      const up_val = [...filter_table, obj];
      ret = up_val;
    }
    this.SetSessionFilterStato(ret, cname);
    return ret;
  }
}
